// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__2S9X0","content":"SubHeader_content__3Wm6k","btnBack":"SubHeader_btnBack__1pG4j","line":"SubHeader_line__944qQ"};